import { VariantServices } from "@/types/types.ts";
import { DeliveryServicesOptions } from "@/components/DeliveryServices/DeliveryServicesOptions.tsx";
import { ESIInclude } from "../__shared__/ESIInclude/ESIInclude";

type Props = {
  /**
   * Indicates if a product variant is available to order.
   */
  availableToOrder: boolean;
  /**
   * The services available for a product variant.
   */
  variantServices: VariantServices;
  /**
   * Feature flag enabling the delivery service questionnaire for complex installs
   */
  deliveryServiceQuestionnaireEnabled: boolean;
  /**
   * Feature flag enabling for testing use of free promo tag on free services
   */
  showFreeServicePromoTag: boolean;
  /**
   * Feature flag enabling service questionnaire drawer (vs modal)
   */
  enableServiceQuestionnaireDrawer: boolean;
};

export const DeliveryServicesUI = ({
  availableToOrder,
  variantServices,
  deliveryServiceQuestionnaireEnabled,
  showFreeServicePromoTag,
  enableServiceQuestionnaireDrawer,
}: Props) => {
  const serviceQuestionnaireScript = `/service-questionnaire/${enableServiceQuestionnaireDrawer ? "drawer" : "index"}.html`;
  return (
    <div
      data-testid="product:services-and-warranties"
      data-component="DeliveryServices"
    >
      <DeliveryServicesOptions
        availableToOrder={availableToOrder}
        variantServices={variantServices}
        deliveryServiceQuestionnaireEnabled={
          deliveryServiceQuestionnaireEnabled
        }
        showFreeServicePromoTag={showFreeServicePromoTag}
      />
      {deliveryServiceQuestionnaireEnabled && (
        <ESIInclude
          src={serviceQuestionnaireScript}
          id={"service-questionnaire"}
        />
      )}
    </div>
  );
};
